import { useCallback } from "react";

import { useBuildSearchParams } from ".";

function useBuildUrl() {
  const buildSearchParams = useBuildSearchParams();

  return useCallback(
    (baseUrl, searchParams) => {
      if (!baseUrl) return "";

      const urlObject = new URL(baseUrl, window.location.origin);
      const existingSearchParams = Array.from(urlObject.searchParams.entries());

      return `${urlObject.origin}${urlObject.pathname}?${buildSearchParams([
        ...existingSearchParams,
        ...searchParams,
      ])}`;
    },
    [buildSearchParams]
  );
}

export default useBuildUrl;
